export abstract class AppError extends Error {
  public readonly customError = true

  constructor(
    name: string,
    message: string,
    public readonly title?: string,
    public readonly statusCode?: number
  ) {
    super(message)
    this.name = name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
